module.exports = __webpack_public_path__ + "img/icon-robbery-gray.76ccbed5.svg";